import { FormControl } from '@angular/forms';
export class CustomSelectValidator {
    static required(f: FormControl) {
        return !(f.value != null && f.value.id >= 1)? {required: { valid:false }}:null;
    }
}